import { useEffect } from "react";
import "./videoBlog.css";

// Add or update your video blogs titles & links here
const videoBlogsSrc = [
  {
    title: "Mango Holidays Virtual Tour London",
    src: "https://youtu.be/KqU9WfkaRdE",
  },
  {
    title: "Mango Holidays Virtual Tour London 1",
    src: "https://youtu.be/TRO5kCgziEA",
  },
  {
    title: "Mango Holidays Virtual Tour London 2",
    src: "https://youtu.be/do8duHQPsKk?si=30qY5cxPpAWzdqxb",
  },
  {
    title: "Mango Holidays Virtual Tour Europe",
    src: "https://youtu.be/yJkJm7fuHQM",
  },
  {
    title: "Mango Holidays Virtual Tour Japan",
    src: "https://youtu.be/7El2NFWnDpI",
  },
  {
    title: "Mango Holidays Virtual Tour South America",
    src: "https://youtu.be/SXeuiZWZW_Y",
  },
  {
    title: "MANGO HOLIDAYS EUROPE TOUR BUS QUALITY",
    src: "https://youtu.be/Bj0gmR9HvKc?si=35Bmrsv_7jwLMwn0",
  },
  {
    title: "Rhine Falls Boat Ride",
    src: "https://www.youtube.com/watch?v=-AyXz_btEqc",
  },
  {
    title: "South America Tour Helicopter Ride",
    src: "https://www.youtube.com/watch?v=kbclWdVMPM8",
  },
  {
    title: "Mango Holidays Europe Tour Happy Customer",
    src: "https://www.youtube.com/watch?v=tF21K5uRc0w",
  },
  {
    title: "EUROPE",
    src: "https://www.youtube.com/watch?v=f2nd1s8Htvw",
  },
  {
    title: "Europe Tours Group",
    src: "https://www.youtube.com/shorts/JphNHjEBFyY",
  },
  {
    title: "Europe Tour Happy Customer",
    src: "https://www.youtube.com/shorts/xq2HFnVAnsk",
  },
];

// Helper function to safely convert any YouTube link into an embeddable iframe URL
const getYouTubeEmbedUrl = (url) => {
  // Updated regex to include 'shorts\/'
  const regExp =
    /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=|shorts\/)([^#&?]*).*/;
  const match = url.match(regExp);

  // If a valid YouTube ID is found (always 11 characters), return the embed link
  if (match && match[2].length === 11) {
    return `https://www.youtube.com/embed/${match[2]}`;
  }

  // Fallback if it's not recognized
  return url;
};

const VideoBlog = () => {
  useEffect(() => {
    document.title = "Travel Video Blogs | Mango Holidays";
  }, []);

  return (
    <>
      {/* Banner Section */}
      <section className="banner-section-videoBlogs">
        <div className="img-container-videoBlogs">
          <img src="/img/video-blog.webp" alt="Banner Unavailable" />
        </div>
        <div className="banner-overlay-videoBlogs">
          <h1 className="banner-title-videoBlogs">Video Blogs</h1>
        </div>
      </section>

      {/* Video Blogs Section */}
      <section className="video-blogs-section">
        {videoBlogsSrc.map((videoSrc, index) => (
          <div key={index} className="video-blog-container">
            <div className="video-container">
              {/* Replaced <video> tag with <iframe> for YouTube compatibility */}
              <iframe
                width="100%"
                height="100%"
                src={getYouTubeEmbedUrl(videoSrc.src)}
                title={videoSrc.title}
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                allowFullScreen
              ></iframe>
            </div>

            <div className="video-title">
              <h2>{videoSrc.title}</h2>
            </div>
          </div>
        ))}
      </section>
    </>
  );
};

export default VideoBlog;
